<script setup lang="ts">
  import type { IHeaderProfile, IProfile } from '@/components/main-header/types'
  import { useUserStore } from '@/stores/User.store'
  import { useGlobalSettingsStore } from '@/stores/GlobalSettings.store'

  const userStore = useUserStore()
  const globalSettingsStore = useGlobalSettingsStore()

  const { isUserLogged, userData } = storeToRefs(userStore)
  const { loginLink } = storeToRefs(globalSettingsStore)

  const props = defineProps<{
    profile: IProfile | IHeaderProfile
  }>()

  const logOutUser = () => {
    userStore.logOutUser()
  }

  const greeting = computed(() => {
    return `${props.profile.greeting}${userData.value.firstName}`
  })

  const profileLinks = computed(() => {
    return userData.value.clean ? props.profile.newProfileLinks : props.profile.oldProfileLinks
  })

  const loginUrl = computed<string>(() => {
    return loginLink.value?.href || ''
  })
</script>

<template>
  <ClientOnly>
    <div v-if="!isUserLogged">
      <LazyProfileNavigationLoginButton
        v-if="loginUrl"
        :title="profile.title"
        :login-url="loginUrl"
      />
    </div>

    <LazyProfileNavigationLoggedIn
      v-else
      :title="profile.title"
      :greeting="greeting"
      :initials="userData?.initials"
      :links="profileLinks"
      @log-out="logOutUser"
    />
  </ClientOnly>
</template>
